import React, { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function Replay() {
  const { data } = useSelector((store) => store.nft);
  const canvasRef = useRef(null);

  const {
    color,
    patch_trace: patch_trace_orig,
    color_scheme,
    color_map,
    background,
  } = data;
  var theme = `rgb( ${color[0]}, ${color[1]}, ${color[2]})`;

  var last = patch_trace_orig[patch_trace_orig.length - 1];
  const wait = 5000; // Wait after animation completes
  const patch_trace = [...patch_trace_orig, [0, '', '', last[3] + wait]];

  const interval = 25; // 40 frames per millisecond

  var text = '';
  var frame = 0;
  var timestamp;

  // control panel
  var tileSize = 20;
  var playSpeed = 2;
  var loadTime = Date.now();

  useEffect(() => {
    const bg_rect = document
      .getElementById('background')
      .getBoundingClientRect();
    const local_canvas = document.getElementById('canvas');
    local_canvas.width = bg_rect.width;
    local_canvas.height = bg_rect.height;

    // if (isMobile.any()) {
    var options = document.getElementById('options');
    options.style.display = 'none';
    // }

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#000000';
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    // https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.contentBoxSize) {
          // Firefox implements `contentBoxSize` as a single content rect, rather than an array
          const contentBoxSize = Array.isArray(entry.contentBoxSize)
            ? entry.contentBoxSize[0]
            : entry.contentBoxSize;
          canvas.width = contentBoxSize.inlineSize;
          canvas.height = window.innerHeight;
        } else if (entry.contentRect) {
          // Safari uses contentRect
          canvas.width = entry.contentRect.width;
          canvas.height = entry.contentRect.height;
        }
      }
    });

    // observe the size of the document
    resizeObserver.observe(document.documentElement);

    var el = document.getElementById('background');
    el.style.backgroundColor = `rgb( ${background[0]}, ${background[1]}, ${background[2]})`;

    // Received data, restart animation
    // eslint-disable-next-line
    frame = 0;
    // eslint-disable-next-line
    text = '';

    tick();
  }, []);

  var isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return (
        navigator.userAgent.match(/IEMobile/i) ||
        navigator.userAgent.match(/WPDesktop/i)
      );
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };

  function break_line(text) {
    var lines = [];

    const canvas = canvasRef.current;
    const width = canvas.width;
    const height = canvas.height;

    const charPerLine = Math.ceil(width / tileSize);
    const maxStackHeight = Math.ceil(height / tileSize);
    const paragraphs = text.split(/\r|\n/);

    for (var i = 0; i < paragraphs.length; i++) {
      var paragraph = paragraphs[i];
      for (var j = 0; j < Math.ceil(paragraph.length / charPerLine); j++) {
        var end = Math.min(paragraph.length, (j + 1) * charPerLine);
        lines.push(paragraph.slice(j * charPerLine, end));
      }
    }
    if (lines.length >= maxStackHeight - 1) {
      return lines.slice(lines.length - maxStackHeight + 2);
    }
    return lines;
  }

  function rebuild_text_with_patch(patch, text) {
    var position = patch[0];
    var oldPatch = patch[1];
    var newPatch = patch[2];
    return (
      text.slice(0, position) +
      newPatch +
      text.slice(position + oldPatch.length)
    );
  }

  function display_text(text, theme, color_scheme, color_map) {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = tileSize - 2 + 'px monospace';
    ctx.fillStyle = theme;
    const lines = break_line(text);
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      for (var j = 0; j < line.length; j++) {
        if (color_scheme === 'rainbow' && color_map[line[j]]) {
          ctx.fillStyle = `rgb( ${color_map[line[j]].join(',')})`;
        }
        ctx.fillText(line[j], j * tileSize, tileSize * (i + 1));
      }
    }
  }

  function draw() {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    if (frame >= patch_trace.length) {
      // Start over
      frame = 0;
      text = '';
      loadTime = Date.now();
    }
    var patch;
    const startTime = patch_trace[0][3];
    const current = Date.now();
    const timeElapsed = (current - loadTime) * playSpeed;
    timestamp = startTime + timeElapsed;

    while (
      frame < patch_trace.length &&
      patch_trace[frame][3] - startTime <= timeElapsed
    ) {
      patch = patch_trace[frame];
      text = rebuild_text_with_patch(patch, text);
      frame += 1;
    }
    display_text(text, theme, color_scheme, color_map);

    var newDate = new Date(timestamp);
    ctx.fillText(newDate.toLocaleString(), 0, canvas.height - 5);
  }

  // MAIN LOOP
  function tick() {
    draw();
    setTimeout(tick, interval);
  }

  var b_isFullscreen = false;

  function fullscreen() {
    var elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen(); // Safari
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen(); // IE11
    }
  }

  function exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen(); // Safari
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen(); // IE11
    }
  }

  function toggleFullscreen() {
    if (!b_isFullscreen) {
      fullscreen();
      b_isFullscreen = true;
    } else {
      exitFullscreen();
      b_isFullscreen = false;
    }
  }

  function updateTileSize(e) {
    tileSize = Math.min(Math.max(e.target.value, 10), 100);
  }

  function updatePlaySpeed() {
    const newPlaySpeed = document.getElementById('speed').value;
    frame = 0;
    text = '';

    const current = Date.now();
    const newLoadTime =
      current - (current - loadTime) * (playSpeed / newPlaySpeed);

    playSpeed = newPlaySpeed;
    loadTime = newLoadTime;
  }

  return (
    <div
      style={{ margin: 0, padding: 0, backgroundColor: 'black' }}
      id='background'
    >
      <canvas ref={canvasRef} id='canvas' width='1280' height='720'></canvas>
      <div
        id='options'
        style={{
          position: 'absolute',
          right: '0px',
          bottom: '0px',
          padding: '2px',
          opacity: 0.5,
          backgroundColor: '#aaaaaa',
          fontFamily: 'monospace',
        }}
      >
        <button onClick={toggleFullscreen}>Fullscreen</button>
        <table>
          <tbody>
            <tr>
              <td>Size</td>
              <td>
                <input
                  type='number'
                  id='tileSize'
                  value={tileSize}
                  onChange={updateTileSize}
                  min='10'
                  max='100'
                  step='1'
                />
              </td>
            </tr>
            <tr>
              <td>Speed</td>
              <td>
                <input
                  type='number'
                  id='fadeFactor'
                  value={playSpeed}
                  onChange={updatePlaySpeed}
                  min='1'
                  max='10'
                  step='0.1'
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
